// Imports
import Axios from 'axios'
import { useLocalBackend, localBackend } from '@/api/config/localBackend'

let AxiosConfig
if (useLocalBackend) {
  // Development only: the local Foreplay server, proxied on this origin
  AxiosConfig = Axios.create({ baseURL: localBackend.serverUrl })
} else if (process.env.VUE_NODE_ENV === 'development') {
  // Axios Config
  AxiosConfig = Axios.create({
    baseURL: 'https://foreplay-dev-67500.ue.r.appspot.com'
    // baseURL: 'http://localhost:5050'
  })
} else {
  const serverUrl = process.env.VUE_APP_SERVER_ENV === 'staging' ? 'https://dev.api.foreplay.co' : 'https://api.foreplay.co'
  // Axios Config
  AxiosConfig = Axios.create({
   // baseURL: 'http://localhost:5050'
    baseURL: serverUrl
  })
}

export default AxiosConfig
